module.exports = __webpack_public_path__ + "static/media/university.d24cdd1c.jpg";